
import { Component, Vue } from "vue-property-decorator";
import Template from "@/views/system-management/template/index.vue";
import { getUsers } from "@/api/users";
import { getJobPositionList } from "@/api/job-position";
import { getRoles } from "@/api/role";
import { editor } from "@/api/mails";
import { IJobPositionModel, IRoleModel } from "@/api/types";
import {
  getSystemMailConfiguration,
  getSystemMailUsers,
  updateSystemMailUsers,
  updatePushMessage,
  updateCompleted,
  updateTemplate,
} from "@/api/mails";

@Component({
  name: "SystemMailManagement",
  components: { Template },
})
export default class extends Vue {
  private listQuery = {
    keyword: "",
    pageNumber: 1,
    pageSize: 1000,
  };

  private searchUserName = "";
  private jobPositionList: IJobPositionModel[] = [];
  private roleList: IRoleModel[] = [];

  private jobFilterList: Filter[] = [];
  private roleFilterList: Filter[] = [];
  private roleIdAndNameMap: { [key: string]: string } = {};
  private jobPositionIdAndNameMap: { [key: string]: string } = {};

  private userList = [];
  private tableData: SystemMailConfiguration[] = [];
  private seleteTableData = [];
  private documentsConfigurationId = "";

  private infoText = "";
  private template = "";
  private systemMailConfigurationId = "";

  private showPermission = false;
  private dataLoading = false;
  private showTemplatEditor = false;

  created() {
    this.initJobPositions();
    this.initRoles();
    this.getList();
  }

  private async getList() {
    const data: any = await getSystemMailConfiguration();
    this.tableData = data;
  }

  private goto() {
    this.$router.go(-1);
  }

  private filterRole(value, row) {
    return row.roleId === value;
  }

  private filterJob(value, row) {
    return row.jobPositionId === value;
  }

  private async createMailPermission() {
    const userIds = this.seleteTableData.map((x) => x.id);
    await updateSystemMailUsers({
      documentsConfigurationId: this.documentsConfigurationId,
      userIds: userIds,
    }).then(() => {
      this.$message({
        type: "success",
        message: "更新成功!",
      });
    });
    this.showPermission = false;
  }

  private handleSelectionChange(value) {
    this.seleteTableData = value;
  }

  private async getUserList(row) {
    this.dataLoading = true;
    if (row.id) {
      this.documentsConfigurationId = row.id;
    }
    const { content }: any = await getUsers(this.listQuery);
    this.userList = content;
    setTimeout(() => {
      this.dataLoading = false;
    }, 0.5 * 1000);
    this.showPermission = true;
    await this.checkUser();
  }

  private async getTemplatEditor(row: SystemMailConfiguration) {
    const res: any = await editor(row.documentsType.name);
    this.infoText = res;
    this.systemMailConfigurationId = row.id;
    this.template = row.template;
    // switch (row.documentsType.name) {
    //   case "DELIVERY_NOTE":
    //     this.infoText =
    //       "单据号码:${code}\n" +
    //       "              进仓状态:${inState}\n" +
    //       "              出仓状态:${outState}\n" +
    //       "              客户简称:${abbreviation}\n" +
    //       "              流转时间:${dateTime}";
    //     break;
    //   case "HQ_PACKING_LIST":
    //     this.infoText =
    //       "当前状态:${state}\n" +
    //       "              财务状态:${state}\n" +
    //       "              单据号码:${code}\n" +
    //       "              流转时间:${dateTime}";
    //     break;
    //   case "SHIPPING_ORDER":
    //     this.infoText =
    //       "当前状态:${state}\n" +
    //       "              单据号码:${code}\n" +
    //       "              客户简称:${abbreviation}\n" +
    //       "              流转时间:${dateTime}";
    //     break;
    //   case "FACTORY_LOADING_PLAN":
    //     this.infoText =
    //       "单据号码:${code}\n" +
    //       "              客户简称:${abbreviation}\n" +
    //       "              流转时间:${dateTime}\n";
    //     break;
    //   case "HENG_AN_LOADING_PLAN":
    //     this.infoText =
    //       "当前状态:${state}\n" +
    //       "              单据号码:${code}\n" +
    //       "              客户简称:${abbreviation}\n" +
    //       "              流转时间:${dateTime}";
    //     break;
    //   case "BOOKING_ORDER":
    //     this.infoText =
    //       "处理阶段:${state}\n" +
    //       "              单据号码:${code}\n" +
    //       "              客户简称:${abbreviation}\n" +
    //       "              流转时间:${dateTime}" +
    //       "              报关状态:${declarationState}";
    //     break;
    //   default:
    //     this.infoText =
    //       "单据号码:${code}\n" +
    //       "              客户简称:${abbreviation}\n" +
    //       "              流转时间:${dateTime}\n";
    //     break;
    // }
    this.showTemplatEditor = true;
  }

  private async checkUser() {
    const data: any = await getSystemMailUsers({
      documentsConfigurationId: this.documentsConfigurationId,
    });
    const userIds = data.map((d) => d.id);
    const data_ = this.userList.filter((u) => userIds.includes(u.id));
    const multipleTable = this.$refs.multipleTable as any;
    data_.forEach((row) => {
      multipleTable.toggleRowSelection(row);
    });
  }

  private async initJobPositions() {
    const data: any = await getJobPositionList();
    this.jobPositionList = data;
    this.jobFilterList = data.map((d) => new Filter(d.id, d.name));
    this.jobPositionIdAndNameMap = this.jobPositionList.reduce(
      (acc: { [key: string]: string }, cur) => {
        acc[cur.id] = cur.name;
        return acc;
      },
      {}
    ) as { [key: string]: string };
  }

  private async initRoles() {
    const data: any = await getRoles();
    this.roleList = data;
    this.roleFilterList = data.map((d) => new Filter(d.id, d.name));
    this.roleIdAndNameMap = this.roleList.reduce(
      (acc: { [key: string]: string }, cur) => {
        acc[cur.id] = cur.name;
        return acc;
      },
      {}
    ) as { [key: string]: string };
  }

  private rowList: number[];

  private rowListPos: number;

  private getTableSpanList() {
    this.rowList = [];
    this.rowListPos = 0;
    this.tableData.forEach((item, index, arr) => {
      // 表格第一行必须保留
      if (index === 0) {
        this.rowList.push(1);
        this.rowListPos = 0;
      } else {
        // 判断当前行性别与上一行单据是否相同 如果相同则合并
        if (item.documentsType.desc === arr[index - 1].documentsType.desc) {
          this.rowList[this.rowListPos] += 1;
          this.rowList.push(0);
        } else {
          this.rowList.push(1);
          this.rowListPos = index;
        }
      }
    });
  }

  private documentSpanMethod({ rowIndex, columnIndex }) {
    this.getTableSpanList();
    //第一列表格合并行
    if (columnIndex === 0) {
      if (this.rowList[rowIndex]) {
        const rowNum = this.rowList[rowIndex];
        return {
          rowspan: rowNum,
          colspan: rowNum > 0 ? 1 : 0,
        };
      } else {
        return {
          rowspan: 0,
          colspan: 0,
        };
      }
    }
  }

  private async updatePushMessage(row: SystemMailConfiguration) {
    await updatePushMessage(row.id, { pushMessage: row.pushMessage });
  }

  private async updateCompleted(row: SystemMailConfiguration) {
    await updateCompleted(row.id, { completed: row.completed });
  }

  private async updateTemplate() {
    await updateTemplate(this.systemMailConfigurationId, {
      template: this.template,
    });
    this.showTemplatEditor = false;
    this.getList();
  }
}

class DocumentType {
  name: string;
  desc: string;
}

class SystemMailConfiguration {
  id: string;
  documentsType: DocumentType;
  stateName: string;
  stateDesc: string;
  template: string;
  pushMessage: boolean;
  completed: boolean;
}

class Filter {
  value: string;
  text: string;

  constructor(value: string, text: string) {
    this.value = value;
    this.text = text;
  }
}
